import http from "../utils/http-common";

class RegistrationDataService {
  getAll() {
    return http.get("/registration");
  }

  getAllActive() {
    return http.get("/registration/active");
  }

  getByValidFromAndType(valid_from, type) {
    return http.get(`/registration/${valid_from}/${type}`);
  }

  get(id) {
    return http.get(`/registration/${id}`);
  }

  create(data) {
    return http.post("/registration", data);
  }

  update(valid_from, type, data) {
    return http.put(`/registration/${valid_from}/${type}`, data);
  }

  delete(valid_from, type) {
    return http.delete(`/registration/${valid_from}/${type}`);
  }

  deleteByValidFrom(valid_from) {
    return http.delete(`/registration/by-date/${valid_from}`);
  }
}

export default new RegistrationDataService();
